<div class="widget">
    <h4>Trending Topics</h4>
    <ul>
        <li *ngFor="let topic of trendingTopics">
            <a href="/search?q={{ topic.Hashtag }}">#{{ topic.Hashtag }}</a>
            <span>{{ topic.TotalEngagement }} posts</span>
        </li>
    </ul>
</div>
